import enLang from './entries/en_US';
import esLang from './entries/es_ES';
import itLang from './entries/it_IT';
const AppLocale = {
    en: enLang,
    es: esLang,
    it: itLang
};

export default AppLocale;